import { ChatServer } from "./ChatServer";

export class StentorLocalChat implements ChatServer {

    public init(): void {
    }

    public sendOfflineMsg(): void {
    }

    public sendChatMsg(): void {
    }

    public sendChatMsgRequest(): void {
    }

    public sendTyping(): void {
    }

    public setVisitorInfo(): void {
    }

    public sendChatRating(): void {
    }

    public sendFile(): void {
    }

    public markAsRead(): void {
    }

    public flush(): void {
    }

    public dispose(): void {
    }

    public bargeOut(): void {
    }

    public bargeIn(): void {
    }

    public sleep(): void {
    }

    public wakeup(): void {
    }
}
